window.theme = window.theme || {};

/* ================ SLATE ================ */
window.theme = window.theme || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  document.addEventListener(
    'shopify:section:load',
    this._onSectionLoad.bind(this)
  );
  document.addEventListener(
    'shopify:section:unload',
    this._onSectionUnload.bind(this)
  );
  document.addEventListener(
    'shopify:section:select',
    this._onSelect.bind(this)
  );
  document.addEventListener(
    'shopify:section:deselect',
    this._onDeselect.bind(this)
  );
  document.addEventListener(
    'shopify:block:select',
    this._onBlockSelect.bind(this)
  );
  document.addEventListener(
    'shopify:block:deselect',
    this._onBlockDeselect.bind(this)
  );
};

theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
  _createInstance: function (container, constructor) {
    var id = container.getAttribute('data-section-id');
    var type = container.getAttribute('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = Object.assign(new constructor(container), {
      id: id,
      type: type,
      container: container,
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function (evt) {
    var container = document.querySelector(
      '[data-section-id="' + evt.detail.sectionId + '"]'
    );

    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function (evt) {
    this.instances = this.instances.filter(function (instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (typeof instance.onUnload === 'function') {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== 'undefined' &&
      typeof instance.onSelect === 'function'
    ) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== 'undefined' &&
      typeof instance.onDeselect === 'function'
    ) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== 'undefined' &&
      typeof instance.onBlockSelect === 'function'
    ) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== 'undefined' &&
      typeof instance.onBlockDeselect === 'function'
    ) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function (type, constructor) {
    this.constructors[type] = constructor;

    document.querySelectorAll('[data-section-type="' + type + '"]').forEach(
      function (container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  },
});

window.slate = window.slate || {};

/**
 * Slate utilities
 * -----------------------------------------------------------------------------
 * A collection of useful utilities to help build your theme
 *
 *
 * @namespace utils
 */

slate.utils = {
  /**
   * Get the query params in a Url
   * Ex
   * https://mysite.com/search?q=noodles&b
   * getParameterByName('q') = "noodles"
   * getParameterByName('b') = "" (empty value)
   * getParameterByName('test') = null (absent)
   */
  getParameterByName: function (name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  },

  keyboardKeys: {
    TAB: 9,
    ENTER: 13,
    ESCAPE: 27,
    LEFTARROW: 37,
    RIGHTARROW: 39,
  },
};

window.slate = window.slate || {};

window.slate = window.slate || {};

/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {
  state: {
    firstFocusable: null,
    lastFocusable: null,
  },
  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects
   *
   * @param {HTMLElement} element - The element to be acted upon
   */
  pageLinkFocus: function (element) {
    if (!element) return;
    var focusClass = 'js-focus-hidden';

    element.setAttribute('tabIndex', '-1');
    element.focus();
    element.classList.add(focusClass);
    element.addEventListener('blur', callback, { once: true });

    function callback() {
      element.classList.remove(focusClass);
      element.removeAttribute('tabindex');
    }
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {HTMLElement} options.container - Container to trap focus within
   * @param {HTMLElement} options.elementToFocus - Element to be focused when focus leaves container
   */
  trapFocus: function (options) {
    var focusableElements = Array.from(
      options.container.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'
      )
    ).filter(function (element) {
      var width = element.offsetWidth;
      var height = element.offsetHeight;

      return (
        width !== 0 &&
        height !== 0 &&
        getComputedStyle(element).getPropertyValue('display') !== 'none'
      );
    });

    this.state.firstFocusable = focusableElements[0];
    this.state.lastFocusable = focusableElements[focusableElements.length - 1];

    if (!options.elementToFocus) {
      options.elementToFocus = options.container;
    }

    options.container.setAttribute('tabindex', '-1');
    options.elementToFocus.focus();

    this._setupHandlers();

    document.addEventListener('focusin', this._onFocusInHandler);
    document.addEventListener('focusout', this._onFocusOutHandler);
  },

  _setupHandlers: function () {
    if (!this._onFocusInHandler) {
      this._onFocusInHandler = this._onFocusIn.bind(this);
    }

    if (!this._onFocusOutHandler) {
      this._onFocusOutHandler = this._onFocusIn.bind(this);
    }

    if (!this._manageFocusHandler) {
      this._manageFocusHandler = this._manageFocus.bind(this);
    }
  },

  _onFocusOut: function () {
    document.removeEventListener('keydown', this._manageFocusHandler);
  },

  _onFocusIn: function (evt) {
    if (
      evt.target !== this.state.lastFocusable &&
      evt.target !== this.state.firstFocusable
    )
      return;

    document.addEventListener('keydown', this._manageFocusHandler);
  },

  _manageFocus: function (evt) {
    if (evt.keyCode !== slate.utils.keyboardKeys.TAB) return;

    /**
     * On the last focusable element and tab forward,
     * focus the first element.
     */
    if (evt.target === this.state.lastFocusable && !evt.shiftKey) {
      evt.preventDefault();
      this.state.firstFocusable.focus();
    }
    /**
     * On the first focusable element and tab backward,
     * focus the last element.
     */
    if (evt.target === this.state.firstFocusable && evt.shiftKey) {
      evt.preventDefault();
      this.state.lastFocusable.focus();
    }
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {HTMLElement} options.container - Container to trap focus within
   */
  removeTrapFocus: function (options) {
    if (options.container) {
      options.container.removeAttribute('tabindex');
    }
    document.removeEventListener('focusin', this._onFocusInHandler);
  },

  /**
   * Add aria-describedby attribute to external and new window links
   *
   * @param {object} options - Options to be used
   * @param {object} options.messages - Custom messages to be used
   * @param {HTMLElement} options.links - Specific links to be targeted
   */
  accessibleLinks: function (options) {
    var body = document.querySelector('body');

    var idSelectors = {
      newWindow: 'a11y-new-window-message',
      external: 'a11y-external-message',
      newWindowExternal: 'a11y-new-window-external-message',
    };

    if (options.links === undefined || !options.links.length) {
      options.links = document.querySelectorAll(
        'a[href]:not([aria-describedby])'
      );
    }

    function generateHTML(customMessages) {
      if (typeof customMessages !== 'object') {
        customMessages = {};
      }

      var messages = Object.assign(
        {
          newWindow: 'Opens in a new window.',
          external: 'Opens external website.',
          newWindowExternal: 'Opens external website in a new window.',
        },
        customMessages
      );

      var container = document.createElement('ul');
      var htmlMessages = '';

      for (var message in messages) {
        htmlMessages +=
          '<li id=' + idSelectors[message] + '>' + messages[message] + '</li>';
      }

      container.setAttribute('hidden', true);
      container.innerHTML = htmlMessages;

      body.appendChild(container);
    }

    function _externalSite(link) {
      var hostname = window.location.hostname;

      return link.hostname !== hostname;
    }

    options.links.forEach(function (link) {
      var target = link.getAttribute('target');
      var rel = link.getAttribute('rel');
      var isExternal = _externalSite(link);
      var isTargetBlank = target === '_blank';

      if (isExternal) {
        link.setAttribute('aria-describedby', idSelectors.external);
      }

      if (isTargetBlank) {
        if (!rel || rel.indexOf('noopener') === -1) {
          var relValue = rel === undefined ? '' : rel + ' ';
          relValue = relValue + 'noopener';
          link.setAttribute('rel', relValue);
        }

        link.setAttribute('aria-describedby', idSelectors.newWindow);
      }

      if (isExternal && isTargetBlank) {
        link.setAttribute('aria-describedby', idSelectors.newWindowExternal);
      }
    });

    generateHTML(options.messages);
  },
};
/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/
 *
 */

theme.Currency = (function () {
  var moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney,
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist.	Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function () {
  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.container = options.container;
    this.product = options.product;
    this.consoles = options.consoles;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.singleOptions = this.container.querySelector(
      options.singleOptionSelector
    );
    this.singleOptionDivs = this.container.querySelectorAll(
      options.singleOptionDiv
    );
    this.singleOptionDivsPre = this.container.querySelector(
      options.singleOptionDiv + '.preselected'
    );
    this.currentVariant = this.singleOptions.value;
    this.currentConsole = false;
    this.consoleFeatures = options.consoleFeatures;
    this.consoleHandle = options.consoleHandle;
    //this.currentConsoleLoaded = false;

    this.singleOptions.addEventListener(
      'change',
      this._onSelectChange.bind(this)
    );
    this.singleOptionDivs.forEach(
      function (option) {
        option.addEventListener(
          'click',
          function (evt) {
            this.singleOptions.value = option.dataset.variantId;
            this.singleOptions.amountOff = option.dataset.amountOff;
            this._onSelectChange();
          }.bind(this)
        );
      }.bind(this)
    );
  }

  Variants.prototype = Object.assign({}, Variants.prototype, {
    /**
     * Find variant based on selected values.
     *
     * @param	{string} selectedValue - Value of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function () {
      var selectedValue = this.singleOptions.value;
      var variants = this.product.variants;

      var found = variants.find(function (variant) {
        return variant.id == selectedValue;
      });

      return found;
    },

    /**
     * Find console based on selected values.
     */
    _getConsoleByVariantId: function () {
      if (!this.consoles) return false;
      var selectedValue = this.singleOptions.value;
      var consoles = this.consoles;

      var found = consoles.find(function (c) {
        return c.id == selectedValue;
      });
      return found;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function () {
      var variant = this._getVariantFromOptions();
      var cons = this._getConsoleByVariantId();
      var disSavings = this.singleOptions.amountOff;
      this.currentConsole = cons;
      console.log('_onSelectChange');
      this.container.dispatchEvent(
        new CustomEvent('variantChange', {
          detail: { variant: variant, cons: cons },
          bubbles: true,
          cancelable: true,
        })
      );

      if (!variant) {
        return;
      }
      if (videoItems && Object.keys(videoItems).length > 1) {
        this._updateVideo(variant, videoItems);
      }
      this._updateImages(variant);
      this._updatePrice(variant, disSavings);
      //this._updateSKU(variant);
      this._updateSections(variant);

      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Update video section when variant changes
     *
     * @param	{object} variant - Currently selected variant
     * @param	{object} videos - Videos
     */
    _updateVideo: function (variant, videoItems) {
      var videoSelected = videoItems[variant.sku];
      var videoSection = document.querySelector('.product-video');
      if (videoSection) {
        if (!videoSelected) {
          videoSelected = Object.values(videoItems)[0];
        }
        var vid = videoSelected.alt.split(':::')[0];
        videoSection.setAttribute('data-video-id', vid);
        var newImg = videoSelected.preview_image.src
          .replace('.jpg', '_1400x.jpg')
          .replace('.png', '_1400x.png');
        videoSection
          .querySelector('.watch-video__poster img')
          .setAttribute('src', newImg);
        var heading = videoSelected.alt.split(':::')[1];
        var headingEl = videoSection.querySelector('.heading-jumbo');
        if (headingEl) headingEl.innerText = heading;
      }
    },
    /**
     * Load Console and trigger event when variant sections change
     *
     * @param	{object} variant - Currently selected variant
     */
    _updateSections: function (variant) {
      var cons = this.currentConsole;
      if (cons) {
        if (this.consoleFeatures) {
          var pict = this.consoleFeatures.querySelector(
            '.product-features-image picture'
          );
          if (pict) pict.classList.add('loader');
        }
        var handle = cons.title
          .toLowerCase()
          .replace(/: /g, ':')
          .split(':')
          .pop()
          .replace(/ /g, '-')
          .replace(/--/g, '-');
        fetch('/products/' + this.consoleHandle + '-' + handle + '?view=json', {
          method: 'GET',
          credentials: 'same-origin',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
          },
        })
          .then(
            function (response) {
              return response.json();
            }.bind(this)
          )
          .then(
            function (json) {
              if (json.status && json.status !== 200) {
                var error = new Error(json.description);
                error.isFromServer = true;
                throw error;
              }
              this.currentConsole.json = json;
              //this.currentConsoleLoaded = true;
              this.container.dispatchEvent(
                new CustomEvent('variantSectionsChange', {
                  detail: { variant: variant, cons: cons },
                  bubbles: true,
                  cancelable: true,
                })
              );
              //console.log(this.currentConsole);
            }.bind(this)
          )
          .catch(function (error) {
            console.log(error);
          });
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param	{object} variant - Currently selected variant
     * @return {event}	variantImageChange
     */
    _updateImages: function (variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};
      //console.log(variant.title+'--'+this.currentVariant.title);
      if (!this.currentVariant || variant.title === this.currentVariant.title) {
        return;
      }

      this.container.dispatchEvent(
        new CustomEvent('variantImageChange', {
          detail: { variant: variant },
          bubbles: true,
          cancelable: true,
        })
      );
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param	{object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function (variant, disSavings) {

      var disPrice = variant.price - disSavings;

      if (
        variant.price === this.currentVariant.price &&
        variant.compare_at_price === this.currentVariant.compare_at_price &&
        variant.unit_price === this.currentVariant.unit_price
      ) {
        return;
      }

      this.container.dispatchEvent(
        new CustomEvent('variantPriceChange', {
          detail: { variant: variant, disPrice: disPrice },
          bubbles: true,
          cancelable: true,
        })
      );
    },

    /**
     * Trigger event when variant sku changes.
     *
     * @param	{object} variant - Currently selected variant
     * @return {event} variantSKUChange
     */
    _updateSKU: function (variant) {
      if (variant.sku === this.currentVariant.sku) {
        return;
      }

      this.container.dispatchEvent(
        new CustomEvent('variantSKUChange', {
          detail: {
            variant: variant,
          },
          bubbles: true,
          cancelable: true,
        })
      );
    },

    /**
     * Update history state for product deeplinking
     *
     * @param	{variant} variant - Currently selected variant
     * @return {k} 				[description]
     */
    _updateHistoryState: function (variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl =
        window.location.protocol +
        '//' +
        window.location.host +
        window.location.pathname +
        '?variant=' +
        variant.id;
      window.history.replaceState({ path: newurl }, '', newurl);
    },
  });

  return Variants;
})();

this.Shopify = this.Shopify || {};
this.Shopify.theme = this.Shopify.theme || {};

/* ================ GLOBAL ================ */
theme.Drawers = (function () {
  function Drawer(id, position, options) {
    var DEFAULT_OPEN_CLASS = 'js-drawer-open';
    var DEFAULT_CLOSE_CLASS = 'js-drawer-close';

    var defaults = {
      selectors: {
        openVariant: '.' + DEFAULT_OPEN_CLASS + '-' + position,
        close: '.' + DEFAULT_CLOSE_CLASS,
      },
      classes: {
        open: DEFAULT_OPEN_CLASS,
        openVariant: DEFAULT_OPEN_CLASS + '-' + position,
      },
      withPredictiveSearch: false,
    };

    this.nodes = {
      parents: [document.documentElement, document.body],
      page: document.querySelector('main'),
    };

    this.eventHandlers = {};

    this.config = Object.assign({}, defaults, options);
    this.position = position;
    this.drawer = document.getElementById(id);

    if (!this.drawer) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  }

  Drawer.prototype.init = function () {
    document
      .querySelector(this.config.selectors.openVariant)
      .addEventListener('click', this.open.bind(this));
    this.drawer
      .querySelector(this.config.selectors.close)
      .addEventListener('click', this.close.bind(this));
  };

  Drawer.prototype.open = function (evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to nodes.page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.activeSource = evt.currentTarget;
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    if (!this.config.withPredictiveSearch) {
      theme.Helpers.prepareTransition(this.drawer);
    }

    this.nodes.parents.forEach(
      function (parent) {
        parent.classList.add(
          this.config.classes.open,
          this.config.classes.openVariant
        );
      }.bind(this)
    );

    this.drawerIsOpen = true;
    var miniCart = document.querySelector('.mini-cart');
    if (miniCart) miniCart.classList.remove('open');
    // Run function when draw opens if set
    if (
      this.config.onDrawerOpen &&
      typeof this.config.onDrawerOpen === 'function'
    ) {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.activeSource && this.activeSource.hasAttribute('aria-expanded')) {
      this.activeSource.setAttribute('aria-expanded', 'true');
    }

    // Set focus on drawer
    var trapFocusConfig = {
      container: this.drawer,
    };

    if (this.config.elementToFocusOnOpen) {
      trapFocusConfig.elementToFocus = this.config.elementToFocusOnOpen;
    }

    slate.a11y.trapFocus(trapFocusConfig);

    this.bindEvents();

    return this;
  };

  Drawer.prototype.close = function () {
    if (!this.drawerIsOpen) {
      // don't close a closed drawer
      return;
    }

    // deselect any focused form elements
    document.activeElement.dispatchEvent(
      new CustomEvent('blur', { bubbles: true, cancelable: true })
    );

    // Ensure closing transition is applied to moved elements, like the nav
    if (!this.config.withPredictiveSearch) {
      theme.Helpers.prepareTransition(this.drawer);
    }

    this.nodes.parents.forEach(
      function (parent) {
        parent.classList.remove(
          this.config.classes.open,
          this.config.classes.openVariant
        );
      }.bind(this)
    );

    if (this.activeSource && this.activeSource.hasAttribute('aria-expanded')) {
      this.activeSource.setAttribute('aria-expanded', 'false');
    }

    this.drawerIsOpen = false;

    // Remove focus on drawer
    slate.a11y.removeTrapFocus({
      container: this.drawer,
    });

    this.unbindEvents();

    // Run function when draw closes if set
    if (
      this.config.onDrawerClose &&
      typeof this.config.onDrawerClose === 'function'
    ) {
      this.config.onDrawerClose();
    }
  };

  Drawer.prototype.bindEvents = function () {
    this.eventHandlers.drawerKeyupHandler = function (evt) {
      // close on 'esc' keypress
      if (evt.keyCode === 27) {
        this.close();
        return false;
      } else {
        return true;
      }
    }.bind(this);

    this.eventHandlers.drawerTouchmoveHandler = function () {
      return false;
    };

    this.eventHandlers.drawerClickHandler = function () {
      this.close();
      return false;
    }.bind(this);

    // Add event listener to document body
    document.body.addEventListener(
      'keyup',
      this.eventHandlers.drawerKeyupHandler
    );

    // Lock scrolling on mobile
    /*this.nodes.page.addEventListener(
			'touchmove',
			this.eventHandlers.drawerTouchmoveHandler
		);*/

    this.nodes.page.addEventListener(
      'click',
      this.eventHandlers.drawerClickHandler
    );
  };

  Drawer.prototype.unbindEvents = function () {
    this.nodes.page.removeEventListener(
      'touchmove',
      this.eventHandlers.drawerTouchmoveHandler
    );
    this.nodes.page.removeEventListener(
      'click',
      this.eventHandlers.drawerClickHandler
    );
    document.body.removeEventListener(
      'keyup',
      this.eventHandlers.drawerKeyupHandler
    );
  };

  return Drawer;
})();

theme.Helpers = (function () {
  var touchDevice = false;

  var classes = {
    preventScrolling: 'prevent-scrolling',
  };

  var scrollPosition = window.pageYOffset;

  function setTouch() {
    touchDevice = true;
  }

  function isTouch() {
    return touchDevice;
  }

  function enableScrollLock() {
    scrollPosition = window.pageYOffset;
    document.body.style.top = '-' + scrollPosition + 'px';
    document.body.classList.add(classes.preventScrolling);
  }

  function disableScrollLock() {
    document.body.classList.remove(classes.preventScrolling);
    document.body.style.removeProperty('top');
    window.scrollTo(0, scrollPosition);
  }

  function debounce(func, wait, immediate) {
    var timeout;

    return function () {
      var context = this,
        args = arguments;

      var later = function () {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };

      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

  function getScript(source, beforeEl) {
    return new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      var prior = beforeEl || document.getElementsByTagName('script')[0];

      script.async = true;
      script.defer = true;

      // eslint-disable-next-line shopify/prefer-early-return
      function onloadHander(_, isAbort) {
        if (
          isAbort ||
          !script.readyState ||
          /loaded|complete/.test(script.readyState)
        ) {
          script.onload = null;
          script.onreadystatechange = null;
          script = undefined;

          if (isAbort) {
            reject();
          } else {
            resolve();
          }
        }
      }

      script.onload = onloadHander;
      script.onreadystatechange = onloadHander;

      script.src = source;
      prior.parentNode.insertBefore(script, prior);
    });
  }

  /* Based on the prepareTransition by Jonathan Snook */
  /* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */
  function prepareTransition(element) {
    element.addEventListener(
      'transitionend',
      function (event) {
        event.currentTarget.classList.remove('is-transitioning');
      },
      { once: true }
    );

    var properties = [
      'transition-duration',
      '-moz-transition-duration',
      '-webkit-transition-duration',
      '-o-transition-duration',
    ];

    var duration = 0;

    properties.forEach(function (property) {
      var computedValue = getComputedStyle(element)[property];

      if (computedValue) {
        computedValue.replace(/\D/g, '');
        duration || (duration = parseFloat(computedValue));
      }
    });

    if (duration !== 0) {
      element.classList.add('is-transitioning');
      element.offsetWidth;
    }
  }

  /*!
   * Serialize all form data into a SearchParams string
   * (c) 2020 Chris Ferdinandi, MIT License, https://gomakethings.com
   * @param	{Node} 	form The form to serialize
   * @return {String}			The serialized form data
   */
  function serialize(form) {
    var arr = [];
    Array.prototype.slice.call(form.elements).forEach(function (field) {
      if (
        !field.name ||
        field.disabled ||
        ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1
      )
        return;
      if (field.type === 'select-multiple') {
        Array.prototype.slice.call(field.options).forEach(function (option) {
          if (!option.selected) return;
          arr.push(
            encodeURIComponent(field.name) +
              '=' +
              encodeURIComponent(option.value)
          );
        });
        return;
      }
      if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked)
        return;
      arr.push(
        encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value)
      );
    });
    return arr.join('&');
  }
  function cookiesEnabled() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled) {
      document.cookie = 'testcookie';
      cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
    }

    return cookieEnabled;
  }

  function promiseStylesheet(stylesheet) {
    var stylesheetUrl = stylesheet || theme.stylesheet;

    if (typeof this.stylesheetPromise === 'undefined') {
      this.stylesheetPromise = new Promise(function (resolve) {
        var link = document.querySelector('link[href="' + stylesheetUrl + '"]');

        if (link.loaded) resolve();

        link.addEventListener('load', function () {
          setTimeout(resolve, 0);
        });
      });
    }

    return this.stylesheetPromise;
  }

  return {
    setTouch: setTouch,
    isTouch: isTouch,
    enableScrollLock: enableScrollLock,
    disableScrollLock: disableScrollLock,
    debounce: debounce,
    getScript: getScript,
    prepareTransition: prepareTransition,
    serialize: serialize,
    cookiesEnabled: cookiesEnabled,
    promiseStylesheet: promiseStylesheet,
  };
})();

/* ================ TEMPLATES ================ */

window.theme = theme || {};

/* eslint-disable no-new */
theme.Product = (function () {
  function Product(container) {
    this.container = container;
    var sectionId = container.getAttribute('data-section-id');
    this.ajaxEnabled = true;

    this.settings = {
      bpSmall: false,
      enableHistoryState:
        container.getAttribute('data-enable-history-state') || false,
      namespace: '.slideshow-' + sectionId,
      sectionId: sectionId,
      sliderActive: false,
    };

    this.selectors = {
      addToCart: '[data-add-to-cart]',

      cartPopup: '[data-cart-popup]',
      cartPopupItems: '[data-cart-items]',
      cartPopupTotal: '[data-cart-total]',
      cartPopupTotalWrapper: '.mini-cart-total',
      cartPopupCartQuantity: '[data-cart-popup-cart-quantity]',
      cartPopupImage: '[data-cart-popup-image]',
      cartPopupImageWrapper: '[data-cart-popup-image-wrapper]',
      cartPopupImagePlaceholder: '[data-image-loading-animation]',
      cartPopupProductDetails: '[data-cart-popup-product-details]',
      cartPopupQuantity: '[data-cart-popup-quantity]',
      cartPopupTitle: '[data-cart-popup-title]',

      loader: '[data-loader]',
      quantity: '[data-quantity-input]',
      SKU: '.variant-sku',
      productStatus: '[data-product-status]',
      productStatusText: '[data-product-status-text]',
      productStatusState: '[data-product-status-state]',
      originalSelectorId: '#ProductSelect-' + sectionId,
      productForm: '[data-product-form]',
      consoleFeatures: '#product-features',
      errorMessage: '[data-error-message]',
      errorMessageWrapper: '[data-error-message-wrapper]',
      //imageZoomWrapper: '[data-image-zoom-wrapper]',
      productMediaWrapper: '.product-view-image',
      /*productThumbImages: '.product-single__thumbnail--' + sectionId,
			productThumbs: '.product-single__thumbnails-' + sectionId,
			productThumbListItem: '.product-single__thumbnails-item',
			productThumbsWrapper: '.thumbnails-wrapper',*/
      saleLabel: '.product-price__sale-label-' + sectionId,
      singleOptionSelector: '.product-form__variants',
      singleOptionDiv: '.product-options__items .product-option',
      shopifyPaymentButton: '.shopify-payment-button',
      priceContainer: '[data-price]',
      regularPrice: '[data-regular-price]',
      saleSavings: '[data-savings-price]',
      msrpPrice: '[data-msrp-price]',
      salePrice: '[data-sale-price]',
      /*unitPrice: '[data-unit-price]',
			unitPriceBaseUnit: '[data-unit-price-base-unit]',*/
      productPolicies: '[data-product-policies]' /*,
			storeAvailabilityContainer: '[data-store-availability-container]'*/,
    };

    this.classes = {
      hidden: 'hide',
      visibilityHidden: 'visibility-hidden',
      inputError: 'input--error',
      jsZoomEnabled: 'js-zoom-enabled',
      productOnSale: 'price--on-sale',
      productUnitAvailable: 'price--unit-available',
      productUnavailable: 'price--unavailable',
      productSoldOut: 'price--sold-out',
      cartImage: 'cart-popup-item__image',
      activeClass: 'active-thumb',
    };

    this.eventHandlers = {};

    this.errorMessageWrapper = container.querySelector(
      this.selectors.errorMessageWrapper
    );
    this.productForm = container.querySelector(this.selectors.productForm);
    this.addToCart = container.querySelectorAll(this.selectors.addToCart);
    this.shopifyPaymentButton = container.querySelector(
      this.selectors.shopifyPaymentButton
    );
    this.priceContainer = container.querySelectorAll(
      this.selectors.priceContainer
    );
    this.productStatus = container.querySelector(this.selectors.productStatus);
    this.productStatusText = this.productStatus.querySelector(
      this.selectors.productStatusText
    );
    this.productStatusState = this.productStatus.querySelector(
      this.selectors.productStatusState
    );
    this.productPolicies = container.querySelector(
      this.selectors.productPolicies
    );

    /*this.storeAvailabilityContainer = container.querySelector(this.selectors.storeAvailabilityContainer);
		if (this.storeAvailabilityContainer) {	this._initStoreAvailability();	}*/
    this.consoleFeatures = container.querySelector(
      this.selectors.consoleFeatures
    );

    this.loader = container.querySelectorAll(this.selectors.loader);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    var productJson = document.getElementById('ProductJson-' + sectionId);
    if (!productJson || !productJson.innerHTML.length) {
      return;
    }
    var consoleJson = document.getElementById('ConsoleJson-' + sectionId);

    this.productSingleObject = JSON.parse(productJson.innerHTML);
    this.consoleSingleObject = false;
    this.consoleHandle = 'console';
    if (consoleJson) {
      this.consoleSingleObject = JSON.parse(consoleJson.innerHTML);
      this.consoleHandle =
        consoleJson.getAttribute('data-handle') == ''
          ? 'console'
          : consoleJson.getAttribute('data-handle');
    }

    // Initial state for global productState object
    this.productState = {
      available: true,
      soldOut: false,
      onSale: false, //,
      //showUnitPrice: false
    };
    this._stringOverrides();
    this._initProductHandlers();
    this._initVariants();
    this._initAddToCart();
  }

  Product.prototype = Object.assign({}, Product.prototype, {
    _stringOverrides: function () {
      theme.productStrings = theme.productStrings || {};
      theme.strings = Object.assign({}, theme.strings, theme.productStrings);
    },

    _initVariants: function () {
      var options = {
        container: this.container,
        enableHistoryState:
          this.container.getAttribute('data-enable-history-state') || false,
        singleOptionSelector: this.selectors.singleOptionSelector,
        singleOptionDiv: this.selectors.singleOptionDiv,
        originalSelectorId: this.selectors.originalSelectorId,
        product: this.productSingleObject,
        consoles: this.consoleSingleObject,
        consoleFeatures: this.consoleFeatures,
        consoleHandle: this.consoleHandle,
      };

      this.variants = new slate.Variants(options);
      if (this.storeAvailability && this.variants.currentVariant.available) {
        this.storeAvailability.updateContent(this.variants.currentVariant.id);
      }

      this.eventHandlers.updateAvailability =
        this._updateAvailability.bind(this);
      this.eventHandlers.updateSections = this._updateSections.bind(this);
      this.eventHandlers.updateMedia = this._updateMedia.bind(this);
      this.eventHandlers.updatePrice = this._updatePrice.bind(this);
      this.eventHandlers.updateSKU = this._updateSKU.bind(this);

      this.container.addEventListener(
        'variantChange',
        this.eventHandlers.updateAvailability
      );
      this.container.addEventListener(
        'variantSectionsChange',
        this.eventHandlers.updateSections
      );
      this.container.addEventListener(
        'variantImageChange',
        this.eventHandlers.updateMedia
      );
      this.container.addEventListener(
        'variantPriceChange',
        this.eventHandlers.updatePrice
      );
      this.container.addEventListener(
        'variantSKUChange',
        this.eventHandlers.updateSKU
      );
    },
    _initProductHandlers: function () {
      console.log('_initProductHandlers');
      var self = this;
      document.addEventListener(
        'click',
        function (e) {
          // loop parent nodes from the target to the delegation node
          if (
            e.target.closest('.compare-modal-option') ||
            e.target.closest('.compare-modal-button')
          ) {
            console.log('compareModelItems click');
            var optionId = e.target.closest('.compare-modal-option')
              ? e.target.closest('.compare-modal-option').dataset.optionId
              : e.target.closest('.compare-modal-button').dataset.optionId;
            var singleOption = self.container.querySelector(
              '.product-options__items [data-option-id="' + optionId + '"]'
            );
            singleOption.click();
          }
        },
        false
      );
      var navBuy = this.container.querySelector('.product-navigation__buy');
      var primaryBuy = this.container.querySelector('.product-view-buy button');

      navBuy.addEventListener(
        'click',
        function (e) {
          primaryBuy.click();
        },
        false
      );
    },

    // cart functions were here

    // init Addtocart features on form submit
    _initAddToCart: function () {
      this.productForm.addEventListener(
        'submit',
        function (evt) {
          evt.preventDefault();
          var fl = false;
          this.addToCart.forEach(function (el) {
            if (el.getAttribute('disabled') === 'true') {
              fl = true;
            }
          });
          if (fl) return;
          if (!this.ajaxEnabled) return;

          this.previouslyFocusedElement = document.activeElement;

          var isInvalidQuantity =
            !!this.quantityInput && this.quantityInput.value <= 0;

          if (isInvalidQuantity) {
            this._showErrorMessage(theme.strings.quantityMinimumMessage);
            return;
          }

          if (!isInvalidQuantity && this.ajaxEnabled) {
            // disable the addToCart and dynamic checkout button while
            // request/cart popup is loading and handle loading state
            this._handleButtonLoadingState(true);
            this._addItemToCart(this.productForm);
            return;
          }
        }.bind(this)
      );
    },

    _addItemToCart: function (form) {
      var self = this;

      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: theme.Helpers.serialize(form),
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (json) {
          if (json.status && json.status !== 200) {
            var error = new Error(json.description);
            error.isFromServer = true;
            if (error.message.includes('Only')) {
              self._setupCartPopup(json);

              const formattedPrice = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD'
              }).format(json.final_price / 100);

              heap.track('Add to Cart', {
                price: formattedPrice,
                brand: json.vendor,
                product_name: json.title,
                sku: json.sku,
                shop_url: window.location.pathname
              });
            }
            throw error;
          }
          self._setupCartPopup(json);
          self._hideErrorMessage();
          self._handleButtonLoadingState(false);

          const formattedPrice = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD'
          }).format(json.final_price / 100);

          heap.track('Add to Cart', {
            price: formattedPrice,
            brand: json.vendor,
            product_name: json.title,
            sku: json.sku,
            shop_url: window.location.pathname
          });
        })
        .catch(function (error) {
          self.previouslyFocusedElement.focus();
          self._showErrorMessage(
            error.isFromServer && error.message.length
              ? error.message
              : theme.strings.cartError
          );
          self._handleButtonLoadingState(false);
          console.log(error);
        });
    },

    // add loader and disabled state to button
    _handleButtonLoadingState: function (isLoading) {
      var classHid = this.classes.hidden;
      if (isLoading) {
        this.addToCart.forEach(function (el) {
          el.setAttribute('disabled', true);
        });

        this.loader.forEach(function (el) {
          el.classList.remove(classHid);
        });

        if (this.shopifyPaymentButton) {
          this.shopifyPaymentButton.setAttribute('disabled', true);
        }
      } else {
        this.addToCart.forEach(function (el) {
          el.removeAttribute('disabled');
        });

        this.loader.forEach(function (el) {
          el.classList.add(classHid);
        });

        if (this.shopifyPaymentButton) {
          this.shopifyPaymentButton.removeAttribute('disabled');
        }
      }
    },

    _showErrorMessage: function (errorMessage) {
      var errorMessageContainer = this.container.querySelector(
        this.selectors.errorMessage
      );
      errorMessageContainer.innerHTML = errorMessage;

      this.errorMessageWrapper.classList.remove(this.classes.hidden);
      this.errorMessageWrapper.setAttribute('aria-hidden', true);
      this.errorMessageWrapper.removeAttribute('aria-hidden');
    },

    _hideErrorMessage: function () {
      this.errorMessageWrapper.classList.add(this.classes.hidden);
    },

    _setupCartPopup: function (item) {
      this._updateCartPopupContent();
      document.querySelector('[data-mini-cart-action]').click();
      setTimeout(function () {
        document.querySelector('.mini-cart .form-buttons button').focus();
      }, 600);
      /*var curItem = this.cartPopup.querySelector('[data-id="'+item.variant_id+'"]')
			if(curItem){
				console.log('exists');
				
			}
			else console.log('not exists');*/
    },

    _updateCartPopupContent: function () {
      var self = this;
      /*console.log('_updateCartPopupContent');
			var quantity = this.quantityInput ? this.quantityInput.value : 1;
			
			this.cartPopupTitle = curEl.querySelector(this.selectors.cartPopupTitle);
			this.cartPopupQuantity = curEl.querySelector(this.selectors.cartPopupQuantity);
			this.cartPopupImagePlaceholder = curEl.querySelector(this.selectors.cartPopupImagePlaceholder);


			this.cartPopupTitle.textContent = item.product_title;
			this.cartPopupQuantity.textContent = quantity;

			this._setCartPopupPlaceholder(item.featured_image.url);
			this._setCartPopupImage(item.featured_image.url, item.featured_image.alt);
			this._setCartPopupProductDetails(
				item.product_has_only_default_variant,
				item.options_with_values,
				item.properties
			);*/
      console.log('_updateCartPopupContent');
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          self._setCartContent(cart);
          //self._showCartPopup();
        })
        .catch(function (error) {
          // eslint-disable-next-line no-console
          console.log(error);
        });
    },

    _setCartContent: function (cart) {
      var self = this;

      this.cartPopupItems =
        this.cartPopupItems ||
        document.querySelector(this.selectors.cartPopupItems);

      this.cartPopupItems.innerHTML = '';
      var idx = 1;
      cart.items.forEach(function (item) {
        self._addCartItem(item, idx);
        idx++;
      });
      /*this.cartPopupCartQuantity = this.cartPopupCartQuantity ||
				document.querySelector(this.selectors.cartPopupCartQuantity);
			var ariaLabel;

			if (quantity === 1) {
				ariaLabel = theme.strings.oneCartCount;
			} else if (quantity > 1) {
				ariaLabel = theme.strings.otherCartCount.replace('[count]', quantity);
			}

			this.cartPopupCartQuantity.textContent = quantity;
			this.cartPopupCartQuantity.setAttribute('aria-label', ariaLabel);*/

      this.cartPopupTotal =
        this.cartPopupTotal ||
        document.querySelector(this.selectors.cartPopupTotal);
      this.cartPopupTotalWrapper =
        this.cartPopupTotalWrapper ||
        document.querySelector(this.selectors.cartPopupTotalWrapper);
      
      this.cartPopupTotal.innerText = theme.Currency.formatMoney(
        cart.total_price,
        theme.moneyFormat
      ) + ' ' + window.currencyIsoCode;
      this.cartPopupTotalWrapper.classList.remove(this.classes.hidden);
    },
    _addCartItem: function (item, idx) {
      var newItem =
        '<div class="mini-cart-item" data-cart-item-index="' + idx + '">';
      var newItemImg = item.image,
        i = newItemImg.lastIndexOf('.');
      if (i != -1) {
        newItemImg = newItemImg.substr(0, i) + '_x190' + newItemImg.substr(i);
      }
      var img =
        '<div class="mini-cart-item__image"><picture><img src="' +
        newItemImg +
        '" alt="' +
        item.product_title +
        '"></picture></div>';
      var price = theme.Currency.formatMoney(
        item.final_price,
        theme.moneyFormat
      );
      newItem += img;
      newItem +=
        '<div class="mini-cart-item__name">' +
        item.product_title +
        ' ' +
        (item.variant_title ? item.variant_title : '') +
        '</div>';
      newItem +=
        '<div class="cart-item__quantity"><div class="product-qty-min"><button type="button" class="dec-qty" data-modifier="-1" aria-label="Decrease quantity of ' + item.product_title + ' by 1">-</button><input min="1" value="' + item.quantity + '" data-quantity-input data-quantity-input-desktop name="quantity" readonly="readonly" data-role="product-quantity-desktop"><button type="button" class="inc-qty" data-modifier="1" aria-label="Increase quantity of ' + item.product_title + ' by 1">+</button></div></div>' +
        '<div class="mini-cart-item__price"><span>';
      newItem +=
        price +
        '</span></div><button class="mini-cart-item__remove" data-cart-remove data-role="product-remove"><span class="icon-trash"></span></button>';
      newItem += '</div>';
      this.cartPopupItems.insertAdjacentHTML('beforeend', newItem);
    },

    _switchMedia: function (option) {
      var newMedia = this.container.querySelectorAll(
        this.selectors.productMediaWrapper + "[data-option='" + option + "']"
      );

      var otherMedia = this.container.querySelectorAll(
        this.selectors.productMediaWrapper +
          ":not([data-option='" +
          option +
          "'])"
      );

      newMedia.forEach(
        function (el) {
          el.classList.remove(this.classes.hidden);
          el.classList.add('active');
        }.bind(this)
      );
      otherMedia.forEach(
        function (el) {
          el.classList.add(this.classes.hidden);
          el.classList.remove('active');
        }.bind(this)
      );
    },

    _enableAddToCart: function (message) {
      this.addToCart.forEach(function (el) {
        el.removeAttribute('disabled');
        el.setAttribute('aria-label', message);
        var elChild = el.querySelector('[data-add-to-cart-text]');
        if (elChild) elChild.innerHTML = message;
      });
      this.productStatusText.innerHTML = theme.strings.inStock;
      this.productStatusState.classList.add('icon-check');
      this.productStatusState.classList.remove('icon-close');
    },

    _disableAddToCart: function (message) {
      console.log('disable cart');
      message = message || theme.strings.unavailable;
      this.addToCart.forEach(function (el) {
        el.setAttribute('disabled', true);
        el.setAttribute('aria-label', message);
        var elChild = el.querySelector('[data-add-to-cart-text]');
        if (elChild) elChild.innerHTML = message;
      });
      this.productStatusText.innerHTML = theme.strings.outOfStock;
      this.productStatusState.classList.add('icon-close');
      this.productStatusState.classList.remove('icon-check');
    },

    _updateAddToCart: function () {
      if (!this.productState.available) {
        this._disableAddToCart(theme.strings.unavailable);
        return;
      }
      if (this.productState.soldOut) {
        this._disableAddToCart(theme.strings.soldOut);
        return;
      }
      this._enableAddToCart(theme.strings.addToCart);
    },
    /**
     * The returned productState object keeps track of a number of properties about the current variant and product
     * Multiple functions within product.js leverage the productState object to determine how to update the page's UI
     * @param {object} evt - object returned from variant change event
     * @return {object} productState - current product variant's state
     *									productState.available - true if current product options result in valid variant
     *									productState.soldOut - true if variant is sold out
     *									productState.onSale - true if variant is on sale
     *									productState.showUnitPrice - true if variant has unit price value
     */
    _setProductState: function (evt) {
      var variant = evt.detail.variant;
      var cons = evt.detail.cons;

      if (!variant) {
        this.productState.available = false;
        return;
      }
      this.productState.available = true;
      this.productState.soldOut =
        !variant.available || (cons && cons.a == false);
      this.productState.onSale = variant.compare_at_price > variant.price;
      //this.productState.showUnitPrice = !!variant.unit_price;
    },
    _updateSections: function (evt) {
      var variant = evt.detail.variant;
      var cons = evt.detail.cons;
      if (!cons) {
        //hide or remove all sections
        return;
      }
      //update tabs section
      /*var tabs = this.container.querySelector('.product-additionaly');
			const tabsSwiper = tabs.querySelector('.product-additionaly__posters').swiper;
			const tabsSwiper2 = tabs.querySelector('.product-additionaly__content').swiper;
			var tabsImgs = tabs.querySelector('.product-additionaly__posters .swiper-wrapper');
			var tabsNav = tabs.querySelectorAll('.product-additionaly__nav-inner button');
			var tabsDesc = tabs.querySelector('.product-additionaly__content .swiper-wrapper');
			if(cons.json && cons.json.ti && cons.json.tt != '' && cons.json.td != ''){
				tabsImgs.innerHTML = "";
				var ti = "",td="";
				cons.json.ti.forEach(
					function(img){
						ti = ti + '<div class="swiper-slide"><div class="product-additionaly-poster"><picture><img src="'+img+'"></picture></div></div>'
					}
				);
				var i = 0;
				tabsNav.forEach(function(tn){tn.innerText="";tn.classList.add(this.classes.hidden);}.bind(this));
				cons.json.tt.forEach(
					function(title){
						tabsNav[i].innerText = title;
						tabsNav[i].classList.remove(this.classes.hidden);
						i++;
					}.bind(this)
				);
				cons.json.td.forEach(
					function(d){
						td = td + '<div class="swiper-slide"><p class="paragraph-large">' + d + '</p></div>'
					}
				);
				tabs.classList.remove(this.classes.hidden);
				tabsImgs.innerHTML = ti;
				tabsDesc.innerHTML = td;
				tabsSwiper.updateSlides();
				tabsSwiper2.updateSlides();
			}
			else{
				tabs.classList.add(this.classes.hidden);
			}*/
      //update display
      var specDisplay = this.container.querySelector(
        '[data-product-spec-display]'
      );
      if (specDisplay) {
        var specDisplayH = specDisplay.querySelector(
          '.product-spec-item__data .heading-4'
        );
        specDisplayH.innerText = cons.display;
        //console.log("updated specDisplay");
      }
      //update iFit membership
      var iDisplay = this.container.querySelector('.product-view-meta__stared'),
        iSpec = document.querySelector('.product-spec-item.ifit'),
        iTech = document.querySelector('.product-technology-section .ifit');
      if (cons.title == 'XR') {
        if (iDisplay) iDisplay.classList.add('hide');
        if (iSpec) iSpec.classList.add('hide');
        if (iTech) iTech.classList.add('hide');
      } else {
        if (iDisplay) iDisplay.classList.remove('hide');
        if (iSpec) iSpec.classList.remove('hide');
        if (iTech) iTech.classList.remove('hide');
      }
      //update features section
      if (this.consoleFeatures) {
        var img = this.consoleFeatures.querySelector(
          '.product-features-image img'
        );
        var pict = this.consoleFeatures.querySelector(
          '.product-features-image picture'
        );
        if (img) img.src = cons.img;
        if (pict)
          setTimeout(function () {
            pict.classList.remove('loader');
          }, 1000);
        var title = this.consoleFeatures.querySelector(
          '.product-features__heading .heading-2'
        );
        title.innerText = cons.headings.PromoTitle
          ? cons.headings.PromoTitle
          : cons.title;
        var specs = this.consoleFeatures.querySelectorAll(
          '.product-feature-item'
        );
        var consSpecs = cons.specs;
        var curKey = false,
          idx = 0;
        specs.forEach(function (spec) {
          spec.classList.add('hide');
        });
        for (var key in consSpecs) {
          curKey = key.split(':::');
          idx = curKey[0];
          curKey = curKey[curKey.length - 1];
          var spec = this.consoleFeatures.querySelector('#pd-' + idx);
          if (spec) {
            spec.classList.remove('hide');
            var spImg = spec.querySelector('.product-feature-item__icon img');
            if (spImg) {
              var spImgSrc = spImg.getAttribute('data-src');
              var spImgSrcArr = spImgSrc.split('/');
              var spImgSrcName = spImgSrcArr[spImgSrcArr.length - 1];
              var spImgSrcNameUpd = 'feature-' + curKey + '.svg';
              spImgSrc = spImgSrc.replace(spImgSrcName, spImgSrcNameUpd);
              spImg.setAttribute('src', spImgSrc);
              spImg.setAttribute('data-src', spImgSrc);
            }
            var spText = spec.querySelector('.product-feature-item__content');
            spText.innerText = consSpecs[key];
          }
        }
        var consoleSwiper = this.consoleFeatures.querySelector(
          '.product-features-slider.swiper-container'
        );
        if (consoleSwiper && consoleSwiper.swiper) {
          consoleSwiper = consoleSwiper.swiper;
          consoleSwiper.update();
        }
      }
      //update chargeafter
      const prod = document.querySelector(
        '[data-widget-type="default-template"]'
      );
      if (prod) {
        ChargeAfter.promotionalWidget.update({
          items: [
            {
              sku: prod.getAttribute('data-widget-item-sku'),
              price: parseFloat(variant.price / 100),
            },
          ],
        });
      }
      /*consSpecs.forEach(function(spec){
				console.log(spec);
			})*/
      /*specs.forEach(function(spec) {
				var sp = spec.getAttribute('id').replace(/pd-/,'');
				var spText = spec.querySelector('.product-feature-item__content');
				if(consSpecs[sp]) spText.innerText = consSpecs[sp];
				else{
					spText.innerText = '';
				}
			});*/
    },
    _updateAvailability: function (evt) {
      // remove error message if one is showing
      this._hideErrorMessage();

      // set product state
      this._setProductState(evt);

      // update store availabilities info
      this._updateStoreAvailabilityContent(evt);
      // update form submit
      this._updateAddToCart();

      this._updatePriceComponentStyles(evt);
    },

    _updateStoreAvailabilityContent: function (evt) {
      if (!this.storeAvailability) {
        return;
      }

      if (this.productState.available && !this.productState.soldOut) {
        this.storeAvailability.updateContent(evt.detail.variant.id);
      } else {
        this.storeAvailability.clearContent();
      }
    },

    _updateMedia: function (evt) {
      var variant = evt.detail.variant;
      this._switchMedia(variant.title);
    },

    _hidePriceComponent: function () {
      this.priceContainer.forEach(function (priceContainer) {
        priceContainer.classList.add(this.classes.productUnavailable);
        priceContainer.setAttribute('aria-hidden', true);
      });
      if (this.productPolicies) {
        this.productPolicies.classList.add(this.classes.visibilityHidden);
      }
    },

    _updatePriceComponentStyles: function (evt) {
      var variant = evt.detail.variant;

      /*var unitPriceBaseUnit = this.priceContainer.querySelector(
				this.selectors.unitPriceBaseUnit
			);*/

      if (!this.productState.available) {
        this._hidePriceComponent();
        return;
      }

      if (this.productState.soldOut) {
        this.priceContainer.forEach(
          function (priceContainer) {
            priceContainer.classList.add(this.classes.productSoldOut);
          }.bind(this)
        );
      } else {
        this.priceContainer.forEach(
          function (priceContainer) {
            priceContainer.classList.remove(this.classes.productSoldOut);
          }.bind(this)
        );
      }

      /*if (this.productState.showUnitPrice) {
				unitPriceBaseUnit.innerHTML = this._getBaseUnit(variant);
				this.priceContainer.classList.add(this.classes.productUnitAvailable);
			} else {
				this.priceContainer.classList.remove(this.classes.productUnitAvailable);
			}*/

      /*if (this.productState.onSale) {
				this.priceContainer.classList.add(this.classes.productOnSale);
			} else {
				this.priceContainer.classList.remove(this.classes.productOnSale);
			}*/

      this.priceContainer.forEach(
        function (priceContainer) {
          priceContainer.classList.remove(this.classes.productUnavailable);
          priceContainer.removeAttribute('aria-hidden');
        }.bind(this)
      );
      if (this.productPolicies) {
        this.productPolicies.classList.remove(this.classes.visibilityHidden);
      }
    },

    _updatePrice: function (evt) {
      var variant = evt.detail.variant;
      var disPrice = evt.detail.disPrice;
      console.log('_updatePrice');
      var regularPrices = this.container.querySelectorAll(
        this.selectors.regularPrice
      );
      var savingsPrice = this.container.querySelectorAll(
        this.selectors.saleSavings
      );
      var msrpPrices = this.container.querySelectorAll(
        this.selectors.msrpPrice
      );
      //var salePrice = this.priceContainer.querySelectorAll(this.selectors.salePrice);
      /*var unitPrice = this.priceContainer.querySelector(
				this.selectors.unitPrice
			);*/

      var formatRegularPrice = function (regularPriceElement, price) {
        regularPriceElement.innerHTML = theme.Currency.formatMoney(
          price,
          theme.moneyFormat
        );
      };

      msrpPrices.forEach(function (regularPrice) {
        formatRegularPrice(regularPrice, variant.compare_at_price);
      });
      regularPrices.forEach(function (regularPrice) {
        formatRegularPrice(regularPrice, disPrice);
      });
      savingsPrice.forEach(function (updateSavingsPrice) {
        updateSavingsPrice.innerHTML =
          ' Save $' +
          (
            Math.round(variant.compare_at_price / 100 - disPrice / 100) / 1
          ).toLocaleString('en-US') +
          ' (' + Math.round(((variant.compare_at_price - disPrice) / variant.compare_at_price) * 100) + '%)';

        console.log(
          updateSavingsPrice.innerHTML.toLocaleString('en-US')
        );
        //(Math.round(num1 * 100) / 100).toFixed(2);
        //updateSavingsPrice.innerHTML = Number(updateSavingsPrice.innerHTML = (variant.compare_at_price - variant.price) / 100).value;

        //console.log(updateSavingsPrice.innerHTML)
      });

      // On sale
      /*if (this.productState.onSale) {
				regularPrices.forEach(function(regularPrice) {
					formatRegularPrice(regularPrice, variant.compare_at_price);
				});
				salePrice.innerHTML = theme.Currency.formatMoney(
					variant.price,
					theme.moneyFormat
				);
			} else {
				// Regular price
				regularPrices.forEach(function(regularPrice) {
					formatRegularPrice(regularPrice, variant.price);
				});
			}*/

      // Unit price
      /*if (this.productState.showUnitPrice) {
				unitPrice.innerHTML = theme.Currency.formatMoney(
					variant.unit_price,
					theme.moneyFormat
				);
			}*/
    },

    /*_getBaseUnit: function(variant) {
			return variant.unit_price_measurement.reference_value === 1
				? variant.unit_price_measurement.reference_unit
				: variant.unit_price_measurement.reference_value +
						variant.unit_price_measurement.reference_unit;
		},*/

    _updateSKU: function (evt) {
      var variant = evt.detail.variant;

      // Update the sku
      var sku = document.querySelector(this.selectors.SKU);
      if (!sku) return;
      sku.innerHTML = variant.sku;
    },

    onUnload: function () {
      this.container.removeEventListener(
        'variantChange',
        this.eventHandlers.updateAvailability
      );
      this.container.removeEventListener(
        'variantSectionsChange',
        this.eventHandlers.updateSections
      );
      this.container.removeEventListener(
        'variantImageChange',
        this.eventHandlers.updateMedia
      );
      this.container.removeEventListener(
        'variantPriceChange',
        this.eventHandlers.updatePrice
      );
      this.container.removeEventListener(
        'variantSKUChange',
        this.eventHandlers.updateSKU
      );
    },
  });

  return Product;
})();

window.theme = window.theme || {};

theme.SearchDrawer = (function () {
  var selectors = {
    headerSection: '[data-header-section]',
    drawer: '[data-predictive-search-drawer]',
    drawerOpenButton: '[data-predictive-search-open-drawer]',
    headerSearchInput: '[data-predictive-search-drawer-input]',
    predictiveSearchWrapper: '[data-predictive-search-mount="drawer"]',
  };

  var drawerInstance;

  function init() {
    setAccessibilityProps();
    drawerInstance = new theme.Drawers('SearchDrawer', 'top', {
      onDrawerOpen: function () {
        //setHeight();
        //theme.MobileNav.closeMobileNav();
        lockBodyScroll();
      },
      onDrawerClose: function () {
        /*theme.SearchHeader.clearAndClose();*/
        var drawerOpenButton = document.querySelector(
          selectors.drawerOpenButton
        );
        if (drawerOpenButton) drawerOpenButton.focus();
        unlockBodyScroll();
      },
      withPredictiveSearch: true,
      elementToFocusOnOpen: document.querySelector(selectors.headerSearchInput),
    });
  }

  function setAccessibilityProps() {
    var drawerOpenButton = document.querySelector(selectors.drawerOpenButton);

    if (drawerOpenButton) {
      drawerOpenButton.setAttribute('aria-controls', 'SearchDrawer');
      drawerOpenButton.setAttribute('aria-expanded', 'false');
      drawerOpenButton.setAttribute('aria-controls', 'dialog');
    }
  }

  /*function setHeight() {
	var searchDrawer = document.querySelector(selectors.drawer);
	var headerHeight = document.querySelector(selectors.headerSection).offsetHeight;
	searchDrawer.style.height = headerHeight + 'px';
}*/

  function close() {
    drawerInstance.close();
  }

  function lockBodyScroll() {
    theme.Helpers.enableScrollLock();
  }

  function unlockBodyScroll() {
    theme.Helpers.disableScrollLock();
  }

  return {
    init: init,
    close: close,
  };
})();

theme.HeaderSection = (function () {
  function Header() {
    theme.SearchDrawer.init();
    //theme.Search.init();
    this.selectors = {
      cartPopup: '[data-cart-popup]',
      cartPopupItems: '[data-cart-items]',
      cartPopupTotal: '[data-cart-total]',
      cartPopupTotalWrapper: '.mini-cart-total',
      cartPopupCartQuantity: '[data-cart-popup-cart-quantity]',
      cartPopupImage: '[data-cart-popup-image]',
      cartPopupImageWrapper: '[data-cart-popup-image-wrapper]',
      cartPopupImagePlaceholder: '[data-image-loading-animation]',
      cartPopupProductDetails: '[data-cart-popup-product-details]',
      cartPopupQuantity: '[data-cart-popup-quantity]',
      cartPopupTitle: '[data-cart-popup-title]'
    };

    this.classes = {
      hidden: 'hide',
    };

    this._initCartPopup();
  }

  Header.prototype = Object.assign({}, Header.prototype, {
    onUnload: function () {
      theme.Search.unload();
    },
    // init cartPopup features
    _initCartPopup: function () {
      console.log('_initCartPopup');
      this.cartPopup =
        this.cartPopup || document.querySelector(this.selectors.cartPopup);
      this.cartPopupTotal =
        this.cartPopupTotal ||
        document.querySelector(this.selectors.cartPopupTotal);
      this.cartPopupTotalWrapper =
        this.cartPopupTotalWrapper ||
        document.querySelector(this.selectors.cartPopupTotalWrapper);
      this.cartPopupItems =
        this.cartPopupItems ||
        document.querySelector(this.selectors.cartPopupItems);
      this.cartPopup.addEventListener(
        'click',
        this._onRemoveItem.bind(this),
        false
      );
    },
    _onRemoveItem: function (e) {
      console.log('_onRemoveItem');
      // loop parent nodes from the target to the delegation node
      var _self = this;
      if (e.target.closest('.mini-cart-item__remove')) {
        var itemEl = e.target.closest('.mini-cart-item');
        var index = parseInt(itemEl.getAttribute('data-cart-item-index'));

        var request = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json;' },
          body: JSON.stringify({
            line: index,
            quantity: 0,
          }),
        };

        fetch('/cart/change.js', request)
          .then(function (response) {
            return response.json();
          })
          .then(function (state) {
            if (state.item_count === 0) {
              _self._emptyCart();
            } else {
              itemEl.remove();
              _self._updateIndex();
            }
            console.log('removed');
            return state;
          })
          .then(function (cart) {
            _self.cartPopupTotal.innerText = theme.Currency.formatMoney(
              cart.total_price,
              theme.moneyFormat
            ) + ' ' + window.currencyIsoCode;
            _self.cartPopupTotalWrapper.classList.remove(_self.classes.hidden);
          })
          .catch(function (error) {
            _self._showCartError(
              error.isFromServer && error.message.length
                ? error.message
                : theme.strings.cartError
            );
            console.log(error);
          });
      } else if (e.target.closest('.dec-qty')) {
        const t = e.target.closest('.dec-qty').nextElementSibling;
        const n = parseInt(e.target.dataset.modifier) || -1;
        var r = parseInt(t.value) + n;
        if (r < 1) {
          r = 1;
        }

        var itemEl = e.target.closest('.mini-cart-item');
        var index = parseInt(itemEl.getAttribute('data-cart-item-index'));

        var request = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json;' },
          body: JSON.stringify({
            line: index,
            quantity: r,
          }),
        };

        fetch('/cart/change.js', request)
          .then(function (response) {
            return response.json();
          })
          .then(function (state) {
            t.value = r;
            console.log('quantity updated');
            return state;
          })
          .then(function (cart) {
            _self.cartPopupTotal.innerText = theme.Currency.formatMoney(
              cart.total_price,
              theme.moneyFormat
            )  + ' ' + window.currencyIsoCode;
            _self.cartPopupTotalWrapper.classList.remove(_self.classes.hidden);
          })
          .catch(function (error) {
            _self._showCartError(
              error.isFromServer && error.message.length
                ? error.message
                : theme.strings.cartError
            );
            console.log(error);
          });
      } else if (e.target.closest('.inc-qty')) {
        const t = e.target.closest('.inc-qty').previousElementSibling;
        const n = parseInt(e.target.dataset.modifier) || 1;
        var r = parseInt(t.value) + n;

        var itemEl = e.target.closest('.mini-cart-item');
        var index = parseInt(itemEl.getAttribute('data-cart-item-index'));

        var request = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json;' },
          body: JSON.stringify({
            line: index,
            quantity: r,
          }),
        };

        fetch('/cart/change.js', request)
          .then(function (response) {
            return response.json();
          })
          .then(function (json) {
            if (json.status && json.status !== 200) {
              var error = new Error(json.description);
              error.isFromServer = true;
              throw error;
            }
            t.value = r;
            console.log('quantity updated');
            return json;
          })
          .then(function (cart) {
            _self.cartPopupTotal.innerText = theme.Currency.formatMoney(
              cart.total_price,
              theme.moneyFormat
            ) + ' ' + window.currencyIsoCode;
            _self.cartPopupTotalWrapper.classList.remove(_self.classes.hidden);
          })
          .catch(function (error) {
            _self._showCartError(
              error.isFromServer && error.message.length
                ? error.message
                : theme.strings.cartError
            , t.value);
            console.log(error);
          });
      }
    },

    // Update index of cart items
    _updateIndex: function () {
      const items = document.querySelectorAll('.mini-cart-item');
      var idx = 1;
      items.forEach((item) => {
        item.dataset.cartItemIndex = idx;
        idx++;
      });
    },

    _emptyCart: function () {
      console.log('_emptyCart');
      this.cartPopupItems.innerHTML = '<p>' + theme.strings.cartEmpty + '</p>';
      this.cartPopupTotalWrapper.classList.add(this.classes.hidden);
    },
    _hideCartError: function () {
      document.querySelector('.mini-cart__error').textContent = '';
      document
        .querySelector('.mini-cart__error')
        .classList.add(this.classes.hidden);
    },
    _showCartError: function (msg, t) {
      let verb;
      if (msg.includes('Only')) {
        if (t > 1) {
          verb = 'are';
        } else {
          verb = 'is';
        }
        msg = 'There ' + verb + ' only ' + t + ' available.';
      }
      document.querySelector('.mini-cart__error').textContent =
        msg;
      document
        .querySelector('.mini-cart__error')
        .classList.remove(this.classes.hidden);
    },
  });

  return Header;
})();

document.addEventListener('DOMContentLoaded', function () {
  var sections = new theme.Sections();

  sections.register('header-section', theme.HeaderSection);
  sections.register('product', theme.Product);
  sections.register('product-template', theme.Product);
  sections.register('matrix-product-main', theme.Product);

  /* redirect from registration page to account */
  var captcha = document.getElementById('g-recaptcha'),
    form = document.querySelector('.shopify-challenge__container form');

  if (captcha && form) {
    var b = document.querySelector('.shopify-challenge__button');
    b.classList.add('button');
    b.classList.add('button-primary');
    var formSrc = form.getAttribute('action');
    if (formSrc.indexOf('account') !== -1) {
      var returnTo = document.createElement('div');
      returnTo.innerHTML =
        '<input type="hidden" name="return_to" value="/account" />';
      form.insertBefore(returnTo, captcha);
    }
  }

  const checkoutBtns = document.querySelectorAll('[name="checkout"], [id="checkout"]');
  if (checkoutBtns.length > 0) {
    checkoutBtns.forEach((btn) => {
      document.addEventListener('click', (event) => {
        if (event.target === btn) {
          heap.track('Checkout Started', {cart_total: document.querySelector('[data-cart-total]').textContent});
        }
      }, true);
    });
  }
});